import ProductCard from "@/components/entities/product-card";
import Pager from "@/components/entities/pager";
import { useFavoritesData } from "@/views/favorites/hooks/useFavoritesData";
import { useStore } from "@/hooks/system/useStore";
import ProductCardLoading from "@/components/entities/product-card/loading-card";
import S from "./index.module.scss";

const FavoritesList = () => {
  const { favorites, isLoading } = useFavoritesData();
  const { selectedFilters, setSelectedFilters } = useStore("favorite");

  const pageHandler = (page: number) => {
    setSelectedFilters({ pageNumber: page });
  };

  return (
    <div className={S.gridWrapper}>
      <div className={S.favoritesGrid}>
        {isLoading
          ? new Array(12).fill({ id: 0 }).map((_, idx) => <ProductCardLoading key={idx} />)
          : favorites?.products?.map(product => <ProductCard key={product.id} product={product} />)}
      </div>
      {favorites && (
        <Pager
          activePageNumber={selectedFilters.pageNumber || 1}
          total={favorites.total}
          activePageSize={12}
          onPageChangeHandler={pageHandler}
        />
      )}
    </div>
  );
};

export default FavoritesList;
